var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Text } from "@chakra-ui/react";
import { JobBadges } from "@/components/SearchResults/JobBadges";
import { formatSince } from "@/components/utils";
import { SearchResultsCompanyLogo } from "./SearchResultsCompanyLogo";
export var SearchResultsListItemMobile = function (_a) {
    var job = _a.job, pixels = _a.pixels, styles = _a.styles;
    return (_jsxs(Box, __assign({ css: styles }, { children: [_jsx(Text, __assign({ variant: "listingTitleMobile", as: "h2" }, { children: job.title })), _jsxs(Box, __assign({ display: "flex", gap: "1.5", alignItems: "top" }, { children: [_jsx(Box, __assign({ flexShrink: 0 }, { children: _jsx(SearchResultsCompanyLogo, { job: job, variant: "mobile" }) })), _jsxs(Box, __assign({ display: "flex", flexDirection: "column" }, { children: [_jsx(Text, __assign({ variant: "listingCompany" }, { children: job.company })), _jsx(Text, __assign({ variant: "listingLocation" }, { children: job.location }))] }))] })), _jsx(JobBadges, { job: job }), _jsxs(Text, __assign({ variant: "postedAt" }, { children: ["Posted ", formatSince(job.datePublished)] })), pixels] })));
};
